import React, { useEffect, useState } from "react";
import AppShell from "../../components/AppShell";
import { api, formatErr } from "../../lib/api";
import { toast } from "sonner";
import { AlertTriangle, TrendingDown, Calendar, ClipboardList, Users, ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";

const CARD_META = [
  { key: "diagnostics_pending_review", label: "Diagnósticos por revisar", icon: ClipboardList, link: "/app/admin/diagnosticos", color: "#facc15" },
  { key: "plans_review_pending", label: "Planes en revisión", icon: ClipboardList, link: "/app/admin/plans-v2", color: "#60a5fa" },
  { key: "proposals_pending", label: "Propuestas pendientes", icon: AlertTriangle, link: "/app/admin/proposals", color: "#f87171" },
];

export default function AdminAttention() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/admin/dashboard-v2/attention").then(({ data }) => setData(data)).catch((e) => toast.error(formatErr(e)));
  }, []);

  if (!data) return <AppShell><div style={{ padding: 40, color: "#a3a3a3" }}>Cargando…</div></AppShell>;

  return (
    <AppShell>
      <div style={{ marginBottom: 20 }}>
        <h1 style={{ fontFamily: "Bebas Neue, sans-serif", fontSize: "2rem", letterSpacing: "0.06em", margin: 0 }}>Requiere atención</h1>
        <p style={{ color: "#a3a3a3", fontSize: 13, margin: "4px 0 0" }}>Lo más importante ahora mismo, priorizado.</p>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: 12, marginBottom: 24 }}>
        {CARD_META.map(({ key, label, icon: Ic, link, color }) => (
          <Link key={key} to={link} className="qv-card-anim" style={{ display: "block", background: "#0a0a0a", border: "1px solid rgba(255,255,255,0.06)", padding: 18, borderRadius: 4, textDecoration: "none", color: "#fff" }} data-testid={`attn-card-${key}`}>
            <div style={{ display: "flex", alignItems: "center", gap: 8, color: color, fontSize: 11, letterSpacing: "0.12em", textTransform: "uppercase" }}>
              <Ic size={14} />{label}
            </div>
            <div style={{ fontFamily: "Bebas Neue, sans-serif", fontSize: 48, color: color, lineHeight: 1, marginTop: 8 }}>{data[key] || 0}</div>
          </Link>
        ))}
      </div>

      <Section title="Jugadores con readiness bajo (últimos 7 días)" icon={TrendingDown} color="#f87171">
        {data.readiness_low_clients?.length === 0 ? <Empty text="Nadie en zona baja. Bien."/> :
          data.readiness_low_clients.map((r) => (
            <Row key={r.client_id} to={`/app/admin/clients/${r.client_id}`}
                 left={r.client_name || r.client_id}
                 right={<><b style={{ color: "#f87171" }}>{r.count}</b> días · último {r.last_date} · {r.last_state}</>} />
          ))
        }
      </Section>

      <Section title="Partidos próximos (7 días)" icon={Calendar} color="#60a5fa">
        {data.matches_upcoming?.length === 0 ? <Empty text="Sin partidos programados." /> :
          data.matches_upcoming.map((m) => (
            <Row key={m.id} to={`/app/admin/clients/${m.client_id}`}
                 left={<>{m.client_name || m.client_id} <span style={{ color: "#a3a3a3", fontSize: 12 }}>vs {m.opponent || "?"}</span></>}
                 right={<>{m.date} {m.kickoff_time || ""}</>} />
          ))
        }
      </Section>

      <Section title="Clientes sin sesión próxima (7 días)" icon={Users} color="#a3a3a3">
        {data.clients_without_upcoming_session?.length === 0 ? <Empty text="Todos con sesiones planificadas." /> :
          data.clients_without_upcoming_session.map((c) => (
            <Row key={c.client_id} to={`/app/admin/clients/${c.client_id}`} left={c.client_name} right="Planificar" />
          ))
        }
      </Section>
    </AppShell>
  );
}

function Section({ title, icon: Ic, color, children }) {
  return (
    <div style={{ marginBottom: 20 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10, color: color, fontSize: 12, letterSpacing: "0.14em", textTransform: "uppercase", fontWeight: 600 }}>
        <Ic size={14} /> {title}
      </div>
      <div style={{ background: "#0a0a0a", border: "1px solid rgba(255,255,255,0.06)", borderRadius: 4 }}>{children}</div>
    </div>
  );
}

function Row({ to, left, right }) {
  return (
    <Link to={to} style={{ display: "flex", justifyContent: "space-between", padding: "12px 16px", borderBottom: "1px solid rgba(255,255,255,0.05)", color: "#fff", textDecoration: "none", alignItems: "center" }}>
      <div style={{ fontSize: 14 }}>{left}</div>
      <div style={{ fontSize: 12, color: "#a3a3a3", display: "flex", alignItems: "center", gap: 6 }}>{right} <ChevronRight size={14}/></div>
    </Link>
  );
}

function Empty({ text }) {
  return <div style={{ padding: 20, textAlign: "center", color: "#a3a3a3", fontSize: 13 }}>{text}</div>;
}
